import StraigthenIcon from '@mui/icons-material/Straighten';
import React from 'react';

export const RulerIcon = props => (
  <StraigthenIcon sx={{transform: 'rotate(-45deg)'}} {...props} />
);
